/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

// Early access lottery
export const CLEAR_LOTTERY_APPLICATION_ERROR = 'CLEAR_LOTTERY_APPLICATION_ERROR';
export const DUPLICATED_LOTTERY_APPLICATION = 'DUPLICATED_LOTTERY_APPLICATION';
export const LOTTERY_APPLICATION_IN_CART = 'LOTTERY_APPLICATION_IN_CART';
export const FETCH_USER_APPLICATION_STATUS_COMPLETE =
    'FETCH_USER_APPLICATION_STATUS_COMPLETE';
export const FETCH_USER_APPLICATION_STATUS_ERROR = 'FETCH_USER_APPLICATION_STATUS_ERROR';
export const LOADING_USER_APPLICATION_STATUS = 'LOADING_USER_APPLICATION_STATUS';

export const API_STATUS_ERROR = 'API_STATUS_ERROR';
export const API_STATUS_SUCCESS = 'API_STATUS_SUCCESS';

export const APP_TITLE = 'Lottery Application';

export const APPLICATION_NOT_FOUND_ERROR_EXT =
    'We could not load your pending lottery application. If you still see it in your shopping cart, try removing and adding again.';
export const APPLICATION_NOT_FOUND_ERROR_INT =
    'We could not load your pending lottery application. If you still see it in your shopping cart, try removing and adding again.';

// Lottery type
export const LOTTERY_BLOCK = 'BLOCK';
export const LOTTERY_DAILY = 'DAILY';

export const CAMPER_NON_PRIMARY_TITLE = 'Camper';
export const CAMPER_PRIMARY_TITLE = 'Camper 1 (Primary Applicant)';

export const CAMPING_BASEPATH = '/camping';

export const DEFAULT_CAMPER_TEMPLATE = {
    first_name: '',
    last_name: '',
    email: '',
    phone_number: '',
    is_minor: false,
};

export const DEFAULT_LOTTERY_APPLICATION_ERROR =
    'Lottery Application is not currently available.';
export const DEFAULT_LOTTERY_CONFIGURATION_ERROR =
    "There's no current lottery configuration available.";

export const INTERNAL_PRICE_PER_PERSON = '$6.00';

export const INVALID_PASS_IN_PRICE_REQUEST_EXT =
    'The pass number you have provided is not valid. Please update the pass number or remove the pass to proceed to cart.';
export const INVALID_PASS_IN_PRICE_REQUEST_INT =
    'The provided pass number is not valid. Please update the pass number or remove the pass to proceed to cart.';

export const INVALID_RESPONSE = 'Invalid response';

export const HEADING_APPLICATION_DETAILS = 'Application Details';
export const HEADING_CAMPER_INFORMATION = 'Camper Information';
export const HEADING_GROUP_STAY_LENGTH = 'Group & Length of Stay';
export const HEADING_PRICE_SUMMARY = 'Price Summary';

export const LOTTERY_INFORMATION_TITLE = 'Lottery Information';
export const LOTTERY_SEASON_TYPE = 'Lottery';

export const LOTTERY_OPEN_NOTICE = 'Lottery open for arrivals beginning tomorrow';
export const LOTTERY_COUNT_NOTICE =
    'Only one lottery reservation per account at one time.';

export const MAX_NON_PRIMARY_CAMPERS = 11; // This is Non-Primary camper default value; so the UI will show max of 12 "People in Group"
export const MAX_TOTAL_NIGHTS = 7;

export const TOTAL_IN_GROUP_NOTICE =
    'Six people will be assigned to each campsite; people in one group may be assigned to different campsites.';

export const TOTAL_IN_GROUP_QUESTION_EXT = 'How many people in your Group?';
export const TOTAL_IN_GROUP_QUESTION_INT = 'How many people in the Group?';

export const TOTAL_STAY_NOTICE_EXT =
    'You can register for up to the maximum stay limit ' +
    '(May 1 – September 15, customers are limited to a total of 7 nights in Yosemite Valley)';
export const TOTAL_STAY_NOTICE_INT =
    'Registration can be made for up to the maximum stay limit ' +
    '(May 1 – September 15, customers are limited to a total of 7 nights in Yosemite Valley)';

export const TOTAL_STAY_QUESTION_EXT = 'How many nights do you want to stay?';
export const TOTAL_STAY_QUESTION_INT = 'How many nights of stay?';

export const USER_NOTICE_1_EXT =
    'You must enter the lottery to secure a space at Camp 4, reservations cannot be secured on-site.' +
    'Space is available on a per-person basis and each person wishing to stay at Camp 4 must be present when lottery winner checks in. ' +
    'Names on the lottery application must match photo ids.';
export const USER_NOTICE_1_INT =
    'Entry to the lottery is required to secure a space at Camp 4, reservations cannot be secured on-site.' +
    'Space is available on a per-person basis and each person wishing to stay at Camp 4 must be present when lottery winner checks in. ' +
    'Names on the lottery application must match photo ids.';

export const USER_NOTICE_2_EXT =
    'Six people will be assigned to each campsite; people in one group may be assigned to different campsites. ' +
    "You can register for up to the maximum stay limit (you don't need to register every day).";
export const USER_NOTICE_2_INT =
    'Six people will be assigned to each campsite; people in one group may be assigned to different campsites. ' +
    'Registration can be made for up to the maximum stay limit (registration does need to be made every day).';
